import { combineReducers } from 'redux'

import {
  AiAlwaysOnAutomationsReducer,
  AiAutomationCoreInitialState,
} from 'apps/aiAutomation/store/core'
import { AiAutomationCoreState } from 'apps/aiAutomation/store/core/lib/types'
import { InstantAnswersPlaygroundReducer } from 'apps/aiAutomation/store/instantAnswersPlayground'
import {
  InstantAnswersPlaygroundInitialState,
  InstantAnswersPlaygroundState,
} from 'apps/aiAutomation/store/instantAnswersPlayground/types'

export const aiAutomationReducer = combineReducers({
  core: AiAlwaysOnAutomationsReducer,
  instantAnswersPlayground: InstantAnswersPlaygroundReducer,
})

export interface AiAutomationState {
  core: AiAutomationCoreState
  instantAnswersPlayground: InstantAnswersPlaygroundState
}

export const AiAutomationInitialState = {
  core: AiAutomationCoreInitialState,
  instantAnswersPlayground: InstantAnswersPlaygroundInitialState,
}
